"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingDividerWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var useStyle = styles_1.makeStyles(function (theme) { return ({
    line: {
        display: "flex",
        width: "100%",
        borderStyle: "solid",
        borderTopWidth: 1,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopColor: theme ? theme.app.Setting.color11 : "",
    },
    lineLeftText: {
        display: "flex",
        alignItems: "center",
        height: 20,
        marginLeft: 56,
        paddingLeft: 16,
        paddingRight: 16,
        fontSize: 14,
        fontWeight: 400,
        marginTop: -10,
        color: theme ? theme.app.Setting.color2 : "",
        backgroundColor: theme
            ? theme.app.settingContent.backgroundColor
            : "",
    },
    lineCenter: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        borderStyle: "solid",
        borderTopWidth: 1,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopColor: theme ? theme.app.Setting.color11 : "",
    },
    lineCenterText: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 20,
        paddingLeft: 16,
        paddingRight: 16,
        fontSize: 14,
        fontWeight: 400,
        marginTop: -10,
        color: theme ? theme.app.Setting.color2 : "",
        backgroundColor: theme
            ? theme.app.settingContent.backgroundColor
            : "",
    },
    lineRight: {
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        borderStyle: "solid",
        borderTopWidth: 1,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopColor: theme ? theme.app.Setting.color11 : "",
    },
    lineRightText: {
        display: "flex",
        alignItems: "center",
        height: 20,
        paddingLeft: 16,
        paddingRight: 16,
        marginRight: 56,
        fontSize: 14,
        fontWeight: 400,
        marginTop: -10,
        color: theme ? theme.app.Setting.color2 : "",
        backgroundColor: theme
            ? theme.app.settingContent.backgroundColor
            : "",
    },
}); });
function SettingDividerWrap(props) {
    var orientation = props.orientation, children = props.children;
    var classes = useStyle();
    return (React.createElement("div", null,
        children === undefined && React.createElement("div", { className: classes.line }),
        children && orientation === "left" && (React.createElement("div", { className: classes.line },
            React.createElement("div", { className: classes.lineLeftText }, children))),
        children && (orientation === "center" || orientation === undefined) && (React.createElement("div", { className: classes.lineCenter },
            React.createElement("div", { className: classes.lineCenterText }, children))),
        children && orientation === "right" && (React.createElement("div", { className: classes.lineRight },
            React.createElement("div", { className: classes.lineRightText }, children)))));
}
exports.SettingDividerWrap = SettingDividerWrap;
//# sourceMappingURL=SettingDividerWrap.js.map